exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Home-module__container--1Jx6R{\r\n    width: 100%;\r\n    text-align: center;\r\n    justify-content: center;\r\n    display: flex;\r\n}\r\n\r\n.Home-module__logo--1kO2W{\r\n    margin: 0 auto;\r\n    position: absolute;\r\n    top: 260px;\r\n}", ""]);

// exports
exports.locals = {
	"container": "Home-module__container--1Jx6R",
	"logo": "Home-module__logo--1kO2W"
};